<template>
  <div
    id="pulseMain"
    :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
  >
    <!-- Cover, Survey page -->
    <pulseSurvey
      v-if="accessData && !error && !confirmation"
      :loading-wrap="loadingWrap"
      :role="role"
      :pulse-data="accessData"
      :error.sync="error"
      :error-text.sync="errorText"
      :error-code.sync="errorCode"
      :confirmation.sync="confirmation"
      :confirmed-data.sync="confirmedData"
      :dialog-width="pulseSurveyWidth"
      :dialog-padding="pulseSurveyPadding"
    />

    <!-- Error page -->
    <pulseError
      v-else-if="error"
      :error-code="errorCode"
      :error-text="errorText"
      :dialog-width="dialogWidth"
    />

    <!-- Confirmed page -->
    <pulseConfirmation
      v-else-if="confirmation"
      :role="role"
      :pulse-data="accessData"
      :confirmed-data.sync="confirmedData"
      :dialog-width="dialogWidth"
      :dialog-padding="dialogPadding"
    />

    <Footer />
  </div>
</template>

<script>
import api from '@/api';
import DialogSetting from '@/mixins/dialog';
import Footer from '@/views/dashboard/layout/Footer.vue';
import pulseSurvey from './PulseSurvey.vue';
import pulseError from './PulseError.vue';
import pulseConfirmation from './PulseConfirmation.vue';

export default {
  components: {
    pulseSurvey,
    pulseError,
    pulseConfirmation,
    Footer,
  },

  mixins: [DialogSetting],

  data() {
    return {
      loadingWrap: false,
      role: '',
      error: false,
      errorText: this.$t('pulse.survey.alreadySubmitted'),
      errorCode: 0,
      confirmation: false,
      accessData: {},
      confirmedData: {
        coach: {
          first_name: '',
          last_name: '',
          email: '',
        },
      },
    };
  },

  created() {
    if (this.$route.params.id && this.$route.params.id.length) {
      this.role = 'stakeholder';
    } else {
      this.role = 'leader';
    }
    this.fetchLeaderData();
  },

  methods: {
    async fetchLeaderData() {
      try {
        this.loadingWrap = true;
        let response = null;

        if (this.role === 'leader') {
          response = await api.getLeaderPulseSurvey();
        } else {
          response = await api.getSupporterPulseSurvey(this.$route.params.id);
        }

        this.accessData = response.data;
      } catch (err) {
        if (err.msg) {
          this.errorText = err.msg;
        }

        if (err.code === 406) {
          this.errorCode = 406;
        }
        this.error = true;
      } finally {
        this.loadingWrap = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#pulseMain {
  height: 100%;
  background: #0999b3;

  &.mobileMode {
    height: unset;
    min-height: 100vh;
  }
}
</style>
